import { render, staticRenderFns } from "./ResourcesFilters.vue?vue&type=template&id=46340227&scoped=true"
import script from "./ResourcesFilters.vue?vue&type=script&lang=js"
export * from "./ResourcesFilters.vue?vue&type=script&lang=js"
import style0 from "./ResourcesFilters.vue?vue&type=style&index=0&id=46340227&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46340227",
  null
  
)

export default component.exports